import React, { useCallback } from 'react';

import { useStyles } from './style';
import { Alert } from '@material-ui/lab';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { useRepayOpenInvoiceMutation } from '../../../../api/payment-method';
import { ToastService } from '../../../../shared/services/toastService';

export const RetryPayment: React.FC = React.memo(() => {
  const classes = useStyles();
  const [repayOpenInvoice] = useRepayOpenInvoiceMutation();

  const CustomIcon = (
    <Avatar className={classes.avatar}>
      <LockOutlinedIcon fontSize="small" />
    </Avatar>
  );

  const onRetryPaymentClick = useCallback(() => {
    repayOpenInvoice().then((res) => {
      if ('data' in res && res.data?.success) {
        ToastService.success('Retry payment successfully');
      } else {
        ToastService.error('Failed to retry payment');
      }
    });
  }, []);


  return (
    <Alert
      classes={{ root: classes.root }}
      icon={CustomIcon}
      severity="info"
      action={
        <Button variant="contained" className={classes.upgradeButton} onClick={onRetryPaymentClick}>
          Retry Payment
        </Button>
      }
    >
      <Typography variant="subtitle1" component="div" className={classes.title}>
        Your recent payment was unsuccessful.
      </Typography>
      <Typography variant="body2" component="div" className={classes.description}>
        Please change the default card or retry the payment to avoid interruption to your service.
      </Typography>
    </Alert>
  );
},
);